module.exports = __webpack_public_path__ + "img/login-cube2-1793698374569.png";